import React, { useEffect, useState } from "react";
import "./FeedBack.scss";
import {
  Box,
  Button,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { House } from "lucide-react";
import { CallApi } from "../../API/CallApi/CallApi";
import LoadingBackdrop from "../../Utils/LoadingBackdrop";
import { showToast } from "../../Utils/Tostify/ToastManager";


const FeedBack = () => {
  const navigate = useNavigate();
  const [answers, setAnswers] = useState({});
  const [allFeedBackData, setAllFeedBackData] = useState();
  const [loading, setLoading] = useState(false);
  const [remarkModal, setRemarkModal] = useState(false);
  const [currentQId, setCurrentQId] = useState(null);
  const [remarkText, setRemarkText] = useState("");
  const activeCust = JSON?.parse(sessionStorage.getItem('curruntActiveCustomer'));

  const GetFeedBackData = async () => {
    setLoading(true);
    const Device_Token = sessionStorage.getItem("device_token");

    const body = {
      Mode: "GetFeedbackList",
      Token: `"${Device_Token}"`,
      ReqData: JSON.stringify([
        {
          ForEvt: "GetFeedbackList",
          DeviceToken: Device_Token,
          AppId: 3,
        },
      ]),
    };

    const response = await CallApi(body);
    if (response?.DT) {
      setAllFeedBackData(response?.DT)
    }
    setLoading(false);
  };
  console.log('response: ', allFeedBackData);

  const emojiOptions = [
    { id: "1", label: "Good", emoji: "🙂" },
    { id: "2", label: "Very Good", emoji: "😊" },
    { id: "3", label: "Excellent", emoji: "😍" },
    { id: "4", label: "Average", emoji: "😐" },
  ];

  const starOptions = ["1", "2", "3", "4", "5"];


  useEffect(() => {
    GetFeedBackData();
  }, [])

  const handleOptionChange = (question, optionId) => {
    setAnswers((prev) => ({
      ...prev,
      [question.QuestionId]: {
        ...(prev[question.QuestionId] || {}),
        OptionId: optionId.toString(),
        IsRemark: question.IsRemark,
      }
    }));
  };



  const openRemarkModal = (questionId) => {
    setCurrentQId(questionId);
    setRemarkText(answers?.[questionId]?.Remark || "");
    setRemarkModal(true);
  };


  const saveRemark = () => {
    setAnswers((prev) => ({
      ...prev,
      [currentQId]: {
        ...prev[currentQId],
        IsRemark: 1,
        Remark: remarkText
      }
    }));
    setRemarkModal(false);
  };


  const handleChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };


  const handleSave = async () => {
    const Device_Token = sessionStorage.getItem("device_token");

    const feedbackArray = Object.keys(answers).map((qid) => ({
      QuestionId: qid,
      OptionId: answers[qid].OptionId || "",
      IsRemark: answers[qid].IsRemark.toString(),
      Remark: answers[qid].Remark || ""
    }));

    const body = {
      Mode: "SaveFeedback",
      Token: `"${Device_Token}"`,
      ReqData: JSON.stringify([
        {
          ForEvt: "SaveFeedback",
          DeviceToken: Device_Token,
          AppId: 3,
          CustomerId: activeCust?.CustomerId,
          FeedbackData: feedbackArray
        }
      ])
    };
    await CallApi(body);
    showToast({
      message: "Save Successfully",
      bgColor: "#4caf50",
      fontColor: "#fff",
      duration: 3000,
    });
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  return (
    <div>
      <LoadingBackdrop isLoading={loading} />
      <div className="Header_main">
        <div className="header-container">
          <p className="header_title">Add Feedback</p>
          <div style={{ display: "flex", gap: "15px" }}>
            <Button
              className="AddCustomer_Btn"
              onClick={() => navigate("/")}
              variant="contained"
            >
              <House />
            </Button>
          </div>
        </div>
      </div>
      <div className="feedback-wrapper">
        <Box className="feedback-form">
          {allFeedBackData?.map((q) => {
            const options = [
              q.option1,
              q.option2,
              q.option3,
              q.option4
            ].filter(Boolean);

            return (
              <FormControl key={q.QuestionId} fullWidth className="question-block">
                <Typography className="question-text">
                  {q.Question}
                </Typography>

                {/* ⭐ STAR OPTIONS (Highest Priority) */}
                {q.IsStar === 1 ? (
                  <Box className="star-container">
                    {starOptions.map((star) => {
                      const selected = Number(answers?.[q.QuestionId]?.OptionId) >= Number(star);

                      return (
                        <span
                          key={star}
                          className={`star ${selected ? "active" : ""}`}
                          onClick={() => handleOptionChange(q, star)}
                          role="button"
                          aria-label={`Rate ${star} star`}
                        >
                          ★
                        </span>
                      );
                    })}
                  </Box>


                ) : q.IsEmoji === 1 ? (

                  /* 😊 EMOJI OPTIONS (Second Priority) */
                  <Box className="emoji-container">
                    {emojiOptions.map((item) => {
                      const isActive =
                        answers?.[q.QuestionId]?.OptionId === item.id;

                      return (
                        <Box
                          key={item.id}
                          className={`emoji-item ${isActive ? "active" : ""}`}
                          onClick={() => handleOptionChange(q, item.id)}
                        >
                          <span className="emoji">{item.emoji}</span>
                          <Typography variant="caption">{item.label}</Typography>
                        </Box>
                      );
                    })}
                  </Box>

                ) : (
                  options.length > 0 && (
                    <RadioGroup
                      value={answers?.[q.QuestionId]?.OptionId || ""}
                      onChange={(e) => handleOptionChange(q, e.target.value)}
                    >
                      {options.map((opt, index) => (
                        <FormControlLabel
                          key={index}
                          value={(index + 1).toString()}
                          control={<Radio />}
                          label={opt}
                        />
                      ))}
                    </RadioGroup>
                  )
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                  {q.IsRemark === 1 && (
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => openRemarkModal(q.QuestionId)}
                      style={{ width: "150px" }}
                    >
                      {answers?.[q.QuestionId]?.Remark ? "Edit Remark" : "Add Remark"}
                    </Button>

                  )}
                </div>
              </FormControl>
            );
          })}
        </Box>
      </div>

      <Box className="action-buttons">
        <Button variant="outlined" onClick={() => navigate("/")}>
          Cancel
        </Button>

        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </Box>

      <Dialog open={remarkModal} onClose={() => setRemarkModal(false)} fullWidth>
        <DialogTitle>Add Remark</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={remarkText}
            onChange={(e) => setRemarkText(e.target.value)}
            placeholder="Enter your remark"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRemarkModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveRemark}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FeedBack;